(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tool-beast-automotive-lighting"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.tb-auto');

    sections.forEach((section) => {
      const filters = section.querySelectorAll('[data-filter]');
      const products = section.querySelectorAll('[data-system]');
      const count = section.querySelector('[data-result-count]');

      if (!filters.length || !products.length) return;

      const updateProducts = (filter) => {
        let visible = 0;

        products.forEach((product) => {
          const shouldShow = filter === 'all' || product.dataset.system === filter;
          product.hidden = !shouldShow;
          if (shouldShow) visible += 1;
        });

        if (count) count.textContent = visible;
      };

      filters.forEach((button) => {
        button.addEventListener('click', () => {
          filters.forEach((item) => {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
          });

          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');
          updateProducts(button.dataset.filter);
        });
      });

      updateProducts('all');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tool-beast-fall-workwear"] && !Shopify.designMode) return;
  try {
    
  function initializeFallWorkwear(root) {
    if (!root || root.dataset.fallWorkwearReady === 'true') return;

    const buttons = Array.from(root.querySelectorAll('[data-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-product-card]'));
    const status = root.querySelector('[data-filter-status]');

    if (!buttons.length || !cards.length) return;

    root.dataset.fallWorkwearReady = 'true';

    function applyFilter(filter, label) {
      let visibleCount = 0;

      cards.forEach((card) => {
        const categories = (card.dataset.category || '').split(' ');
        const showCard = filter === 'all' || categories.includes(filter);
        card.hidden = !showCard;
        if (showCard) visibleCount += 1;
      });

      buttons.forEach((button) => {
        const isActive = button.dataset.filter === filter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (status) {
        const showingLabel = root.dataset.showingLabel || 'Showing';
        const productLabel = root.dataset.productLabel || 'products';
        status.textContent =
          filter === 'all'
            ? `${showingLabel} ${visibleCount} ${productLabel}`
            : `${showingLabel} ${visibleCount} ${label.toLowerCase()} ${productLabel}`;
      }
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => applyFilter(button.dataset.filter, button.textContent.trim()));
    });

    applyFilter('all', buttons[0].textContent.trim());
  }

  function initializeAllFallWorkwear(container) {
    const scope = container || document;
    if (scope.matches && scope.matches('[data-fall-workwear]')) {
      initializeFallWorkwear(scope);
    }
    scope.querySelectorAll('[data-fall-workwear]').forEach(initializeFallWorkwear);
  }

  initializeAllFallWorkwear(document);

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllFallWorkwear(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tool-beast-heated-gear"] && !Shopify.designMode) return;
  try {
    
  function initializeHeatedGear(root) {
    if (!root || root.dataset.heatedGearReady === 'true') return;

    const buttons = Array.from(root.querySelectorAll('[data-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-product-card]'));
    const status = root.querySelector('[data-filter-status]');

    if (!buttons.length || !cards.length) return;

    root.dataset.heatedGearReady = 'true';

    function applyFilter(filter, label) {
      let visibleCount = 0;

      cards.forEach((card) => {
        const showCard = filter === 'all' || card.dataset.category === filter;
        card.hidden = !showCard;
        if (showCard) visibleCount += 1;
      });

      buttons.forEach((button) => {
        const isActive = button.dataset.filter === filter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (status) {
        const showingLabel = root.dataset.showingLabel || 'Showing';
        const productLabel = root.dataset.productLabel || 'products';
        status.textContent =
          filter === 'all'
            ? `${showingLabel} ${visibleCount} ${productLabel}`
            : `${showingLabel} ${visibleCount} ${label.toLowerCase()} ${productLabel}`;
      }
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => applyFilter(button.dataset.filter, button.textContent.trim()));
    });

    applyFilter('all', buttons[0].textContent.trim());
  }

  function initializeAllHeatedGear(container) {
    const scope = container || document;
    if (scope.matches && scope.matches('[data-heated-gear]')) {
      initializeHeatedGear(scope);
    }
    scope.querySelectorAll('[data-heated-gear]').forEach(initializeHeatedGear);
  }

  initializeAllHeatedGear(document);

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllHeatedGear(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
